<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('gestao-ar', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
            ref='tableGestaoAR',
            @selection-change='handleSelectionChange',
            :table-layout='tableLayout'
        )
            el-table-column(
                type='selection',
                :selectable='camposSelecionaveis',
                v-if='arquivando',
                align='center',
                width='45',
                fixed='left'
            )
            el-table-column(
                property='numeroContrato',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.numeroContrato")',
                sortable,
                :min-width='getColumnWidth("numeroContrato")',
                show-overflow-tooltip
            )
            el-table-column(
                property='nomeVendedor',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.vendedor")',
                :min-width='getColumnWidth("nomeVendedor")',
                show-overflow-tooltip
            )
            el-table-column(
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.corredor")',
                :min-width='getColumnWidth("corredor")',
                show-overflow-tooltip
            )
                template(slot-scope='{ row }')
                    | {{ row.nomeSucursal ? row.nomeSucursal + ' - ' : '' }}{{ row.subEmpresaNome }}
            el-table-column(
                property='materialNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produto")',
                sortable,
                :min-width='getColumnWidth("materialNome")',
                show-overflow-tooltip
            )
            el-table-column(
                property='safraNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.colheita")',
                :min-width='getColumnWidth("safraNome")',
                show-overflow-tooltip
            )
            el-table-column(
                property='volumeContratado',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
                sortable,
                :min-width='getColumnWidth("volumeContratado")',
                show-overflow-tooltip
            )
            el-table-column(
                property='dataContrato',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
                sortable,
                :min-width='getColumnWidth("dataContrato")',
                show-overflow-tooltip
            )
            el-table-column(
                prop='statusEmpresa',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.statusEmpresa")',
                sortable,
                :min-width='getColumnWidth("statusEmpresa")',
                show-overflow-tooltip
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusEmpresa }}
                    .status-processamento__dias(v-if='scope.row.dataHa')
                        i.mdi.mdi-clock-outline
                        | {{ scope.row.dataHa }} {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.' + (scope.row.dataHa > 1 ? 'dias' : 'dia')) }}

            el-table-column(
                label='',
                align='center',
                width='45',
                fixed='right'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.visualizarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "NAO_VISUALIZADO" || scope.row.statusEmpresaCodigo === "VISUALIZADO"',
                                @click.native='editarContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-square-edit-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.editarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo !== "ARQUIVADO" && scope.row.statusEmpresaCodigo !== "CONCLUIDO"',
                                @click.native='arquivarContrato(scope.row.id)'
                            )
                                i.mdi.mdi-archive
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.arquivar') }}
            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} {{ paginacao.total > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contratos') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contrato') }}
            span.pagina.espacamento-totalizador {{ formatNumber(totalizador) }} {{ totalizador > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorToneladas') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorTonelada') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import formatters from '@/utils/formatters';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'TabelaGestaoContratoOriginacaoEmpresa',
    components: {
        ModalDetalheAnalise
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: Number,
            required: false
        },
        arquivando: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            },
            contratosSelecionados: [],
            numeroContratoSelecionado: '',
            ambientes: AmbientesEmpresas,
            columnWidths: {},
            tableLayout: 'auto'
        };
    },
    mounted() {
        this.calculateColumnWidths();

        this.$nextTick(() => {
            this.adjustTableLayout();
        });
    },
    watch: {
        tabelaData: {
            handler() {
                this.$nextTick(() => {
                    this.calculateColumnWidths();
                    this.adjustTableLayout();
                });
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        calculateColumnWidths() {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            context.font = '14px Roboto';

            const columns = {
                numeroContrato: 'Número do Contrato',
                nomeVendedor: 'Vendedor',
                corredor: 'Corredor',
                materialNome: 'Produto',
                safraNome: 'Colheita',
                volumeContratado: 'Volume Contratado',
                dataContrato: 'Data do Contrato',
                statusEmpresa: 'Status'
            };

            Object.keys(columns).forEach(key => {
                let maxWidth = context.measureText(columns[key]).width + 40;

                this.tabelaData.forEach(item => {
                    let value = '';

                    if (key === 'corredor') {
                        value =
                            (item.nomeSucursal
                                ? item.nomeSucursal + ' - '
                                : '') + item.subEmpresaNome;
                    } else {
                        value = item[key] || '';
                    }

                    const textWidth =
                        context.measureText(value.toString()).width + 40;
                    if (textWidth > maxWidth) {
                        maxWidth = textWidth;
                    }
                });

                const minWidth = key === 'safraNome' ? 100 : 120;
                const maxWidthLimit = key === 'nomeVendedor' ? 350 : 300;

                this.columnWidths[key] = Math.min(
                    Math.max(maxWidth, minWidth),
                    maxWidthLimit
                );
            });
        },

        getColumnWidth(columnName) {
            return this.columnWidths[columnName] || 120;
        },

        adjustTableLayout() {
            this.$nextTick(() => {
                const table = this.$refs.tableGestaoAR;
                if (table && table.$el) {
                    table.doLayout();
                }
            });
        },

        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarContratoOriginacaoEmpresaAR',
                params: { id: numeroContrato }
            });
        },
        editarContrato(numeroContrato) {
            this.$router.push({
                name: 'EditarContratoOriginacaoEmpresaAR',
                params: { id: numeroContrato }
            });
        },
        async exportarRelatorioContrato(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                    )
                );
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/empresa/relatorio/exportado`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.exportarRelatorioFilename'
                                );
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroExportarRelatorio'
                                    )
                                );
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarRelatorioContratoEmpresaPY(
                        numeroContrato
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i>' +
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.downloadEmProcessamento'
                            ),
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                        )
                    );
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.usuarioDeslogado'
                    )
                );
                disconnect();
            }
        },
        handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.arquivarContratos(idsContratosOriginacao);
        },
        async arquivarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarArquivamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('arquivarContrato', idContratoOriginacao);
            }
        },
        limparRemocao() {
            this.$refs.tableGestaoAR.clearSelection();
        },
        arquivarContratos(idsContratosOriginacao) {
            this.$emit('arquivarContratos', idsContratosOriginacao);
        },
        camposSelecionaveis(row, index) {
            const selecionavel =
                row.statusEmpresaCodigo === 'VISUALIZADO' ||
                row.statusEmpresaCodigo === 'EM_CADASTRAMENTO' ||
                row.statusEmpresaCodigo === 'NAO_VISUALIZADO';
            return selecionavel;
        },
        formatNumber(number, decimalPlaces) {
            if (number < 1) {
                return 0;
            }
            return formatters.formatNumber(number, decimalPlaces);
        }
    }
};
</script>

<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    overflow-x: auto; // Adiciona scroll horizontal se necessário

    .tabela-gestao-contrato-originacao__tabela {
        overflow-x: auto;

        @media (max-width: 768px) {
            overflow-x: scroll;
        }
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        width: 100%;
        table-layout: auto; // Permite que as colunas se ajustem automaticamente

        // Para dispositivos móveis
        @media (max-width: 768px) {
            min-width: 1200px; // Define uma largura mínima para manter a estrutura
        }

        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
                white-space: nowrap; // Evita quebra de linha nos cabeçalhos
            }
        }

        // Células da tabela
        .el-table__cell {
            padding: 8px 12px; // Reduz padding em telas menores

            @media (max-width: 768px) {
                padding: 6px 8px;
            }
        }

        // Conteúdo das células
        .cell {
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .el-table th.el-table__cell > .cell {
        font-family: Roboto;
        font-weight: 500;
        font-size: 16px;

        @media (max-width: 768px) {
            font-size: 14px;
        }
    }

    .el-table td.el-table__cell div {
        font-family: Roboto;
        font-weight: 400;
        font-size: 14px;

        @media (max-width: 768px) {
            font-size: 12px;
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 10px;
            text-align: center;
        }

        .pagina {
            color: var(--primary);
            font-weight: 600;

            @media (max-width: 480px) {
                font-size: 14px;
            }
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }

    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;
        i {
            margin-right: 2px;
        }
        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;

        @media (max-width: 768px) {
            margin-left: 0;
            margin-top: 5px;
        }
    }
}

.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}

// Estilos específicos para responsividade
@media (max-width: 1200px) {
    #tabela-gestao-contrato-originacao-empresa {
        .el-table th.el-table__cell > .cell {
            font-size: 14px;
        }

        .el-table td.el-table__cell div {
            font-size: 12px;
        }
    }
}

@media (max-width: 768px) {
    #tabela-gestao-contrato-originacao-empresa {
        margin: 0 -10px; // Expande para usar toda a largura disponível

        .tabela-gestao-contrato-originacao__paginacao {
            padding: 10px;
        }
    }
}
</style>
